<template>
  <b-col sm="12" class="mt-2 mb-2">
    <div class="card">
      <div class="card-header main-card">Chequeo de reservas</div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-9">
            <b-form-group label="Seleccionar actividad">
              <b-form-select
                v-model="filterGroupSelection"
                :options="filterSelectionOptions"
                class="custom-select"
                size="sm"
                style="width:: 100%;"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-lg-3">
            <b-form-group label="Ver" class="d-flex">
              <b-form-radio-group v-model="filtering.filterFold" id="radio-group-ver">
                <b-form-radio name="desplegado" :value="'desplegado'">Desplegado</b-form-radio>
                <b-form-radio name="plegado" :value="'plegado'">Plegado</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          
        </div>
        <Spinner v-if="this.$store.getters.isBookingsForCheckingLoading" color="#fedd00" />
        <div v-else>
          <div v-for="activityGroup in bookingsByActivityForCheck" :key="activityGroup.id" class="mt-2">
            <b-card
              v-if="activityGroup.count_bookings > 0 && (activityGroup.id == filterGroupSelection || filterGroupSelection == 0 )"
              no-body
              class="mb-0 card-listing"
            >
              <b-card-header
                header-tag="header"
                class="p-2 card-header-activity"
                role="tab"
              >
                <div class="align-items-baseline d-flex justify-content-center w-100">
                  <div class="text-center font-weight-bold">
                    {{ activityGroup.name }}
                    <span
                      class="ml-2 badge badge-default"
                      >{{ activityGroup.hora }}</span
                    >
                  </div>
                </div>
                <div class="align-items-baseline d-flex justify-content-center w-100 mt-2">
                  
                  <span class="ml-2 badge badge-default">
                    Totales: {{ activityGroup.count_customers }} personas
                    {{ activityGroup.count_bookings }} reservas</span
                  >
                  <span v-if="allChecked(activityGroup)" class="ml-2 badge badge-success">
                    <i class="fa fa-check-circle fa-fw" style="font: white;"></i>
                    Todas las reservas chequeadas
                  </span>
                  <span v-else class="ml-2 badge badge-danger">
                    <i class="fa fa-exclamation-triangle fa-fw" style="font: white;"></i>
                    Faltan reservas por chequear
                  </span>

                  
                </div>
              </b-card-header>
              <b-card-body
                class="booking-info"
                :id="activityGroup.name"
                :style="{ display: filtering.filterFold == 'desplegado' ? '' : 'none'}"
              >
                <b-card-text>
                  <table class="table table-hover table-sm">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 10%;">Cliente</th>
                        <th scope="col" style="width: 4%;">Num. Reserva</th>
                        <th scope="col" style="width: 10%;">Hotel</th>
                        <th scope="col" style="width: 2%;">Hab.</th>
                        <th scope="col" style="width: 15%;">Actividad</th>
                        <th scope="col" style="width: 2%;">Idioma</th>
                        <th scope="col" style="width: 2%;">Pax</th>
                        <th scope="col" style="width: 2%;">1/2</th>
                        <th scope="col" style="width: 2%;">Total Pax</th>
                        <th scope="col" style="width: 10%;">Parada</th>
                        <th scope="col" style="width: 10%;">Punto venta</th>
                        <th scope="col" style="width: 6%;">Grupo</th>
                        <th scope="col" style="width: 4%;">Estado</th>
                      </tr>
                    </thead>
                    <tbody v-for="(entry, idx) in group(activityGroup.bookings_list)" :key="idx">
                      <tr>
                        <td class="font-weight-bold" colspan="12">{{idx}}</td>
                      </tr>
                      <bookings-check-table-row
                        v-for="(booking, bid) in entry" :key="bid" 
                        :booking="booking" 
                        :bookings="entry"
                        :idx="bid"
                      />
                    </tbody>
                  </table>
                </b-card-text>
              </b-card-body>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    
  </b-col>
</template>

<script>
/* eslint-disable */
import Spinner from "vue-spinner/src/ScaleLoader.vue";
import ShowCompleteBookingModal from "../Modal/ShowCompleteBookingModal";
import { mapGetters } from "vuex";
import BookingsCheckTableRow from './BookingsCheckTableRow.vue';

export default {
  components: {
    Spinner,
    ShowCompleteBookingModal,
    BookingsCheckTableRow
  },
  data() {
    return {
      viewSellingChannelFilter: 'all', // 'select which one to show',
      filterGroupSelection: 0,
      filtering: {
        filterFold: 'desplegado'
      }
    };
  },
  computed: {
    ...mapGetters(['groups', 'groupsListAdmin']),
    ...mapGetters(['activeTab']),
    ...mapGetters(['activeOption']),
    ...mapGetters(['bookingsByActivityForCheck', 'isBookingsForCheckingLoading']),

    filterSelectionOptions() {
      let options = []
      options.push({
        value: 0,
        text: 'Mostrar todas'
      })
      if ( this.bookingsByActivityForCheck != null ) {
        const available = this.bookingsByActivityForCheck.map( (item) => ({
          value: item.id,
          text: item.name
        }))
        console.log("available", available)
        options = options.concat(available)
      }
      
      return options
    }
  },
  async mounted() {
    this.$store.dispatch("bookings/loadBookingsByActivityForCheckingOrdered", {order_by: 'id,customer_language'}, {root: true})
  },
  methods: {
    group(bookings) {
      let g = _.mapValues(
                _.groupBy(
                    bookings, 'integration'
                ),
            )
      return g
    },
    allChecked(group) {
      const test = group.bookings_list.filter( (item) => !item.checked)
      if ( test != null && test.length > 0 ) {
        return false
      }
      return true
    }
  },
};
</script>


<style scoped>
#checks_column i, #stop_column i {
  font-size: 14px;
  margin-left: 2px;
}
</style>